// Конфиг с кодами стран
const COUNTRY_CODES_CONFIG = [
  { code: '+7', length: 1 },    // Россия, Казахстан
  { code: '+380', length: 3 },  // Украина
  { code: '+375', length: 3 },  // Беларусь
  { code: '+1', length: 1 },    // США, Канада
  { code: '+44', length: 2 },   // Великобритания
  { code: '+49', length: 2 },   // Германия
  { code: '+33', length: 2 },   // Франция
  { code: '+39', length: 2 },   // Италия
  { code: '+34', length: 2 },   // Испания
  { code: '+86', length: 2 },   // Китай
  { code: '+81', length: 2 },   // Япония
  { code: '+91', length: 2 },   // Индия
  { code: '+55', length: 2 },   // Бразилия
  { code: '+61', length: 2 },   // Австралия
  { code: '+90', length: 2 },   // Турция
  { code: '+48', length: 2 },   // Польша
  { code: '+420', length: 3 },  // Чехия
  { code: '+36', length: 2 },   // Венгрия
  { code: '+40', length: 2 },   // Румыния
  { code: '+359', length: 3 },  // Болгария
  { code: '+353', length: 3 },  // Ирландия
  { code: '+31', length: 2 },   // Нидерланды
  { code: '+32', length: 2 },   // Бельгия
  { code: '+41', length: 2 },   // Швейцария
  { code: '+43', length: 2 },   // Австрия
  { code: '+45', length: 2 },   // Дания
  { code: '+46', length: 2 },   // Швеция
  { code: '+47', length: 2 },   // Норвегия
  { code: '+358', length: 3 },  // Финляндия
  { code: '+351', length: 3 },  // Португалия
  { code: '+30', length: 2 },   // Греция
  { code: '+54', length: 2 },   // Аргентина
  { code: '+52', length: 2 },   // Мексика
  { code: '+56', length: 2 },   // Чили
  { code: '+57', length: 2 },   // Колумбия
  { code: '+51', length: 2 },   // Перу
  { code: '+598', length: 3 },  // Уругвай
  { code: '+595', length: 3 },  // Парагвай
  { code: '+593', length: 3 },  // Эквадор
  { code: '+20', length: 2 },   // Египет
  { code: '+27', length: 2 },   // ЮАР
  { code: '+234', length: 3 },  // Нигерия
  { code: '+254', length: 3 },  // Кения
  { code: '+966', length: 3 },  // Саудовская Аравия
  { code: '+971', length: 3 },  // ОАЭ
  { code: '+972', length: 3 },  // Израиль
  { code: '+82', length: 2 },   // Южная Корея
  { code: '+84', length: 2 },   // Вьетнам
  { code: '+66', length: 2 },   // Таиланд
  { code: '+60', length: 2 },   // Малайзия
  { code: '+65', length: 2 },   // Сингапур
  { code: '+62', length: 2 },   // Индонезия
  { code: '+63', length: 2 },   // Филиппины
];

const COUNTRY_CODE_LENGTHS = new Map(
  COUNTRY_CODES_CONFIG.map(({ code, length }) => [code, length])
);
const MAX_COUNTRY_CODE_SIZE = Math.max(
  ...COUNTRY_CODES_CONFIG.map(({ code }) => code.length)
);

export function formatPhoneNumber(phone) {
  if (!phone) {
    return '';
  }
  
  const phoneWithPlus = phone.startsWith('+') ? phone : '+' + phone;
  const digits = phoneWithPlus.match(/\d/g)?.join('') || '';
  
  let code = '';
  let value = digits;
  
  for (let size = MAX_COUNTRY_CODE_SIZE; size > 1; size--) {
    const candidate = phoneWithPlus.slice(0, size);
    const length = COUNTRY_CODE_LENGTHS.get(candidate);
    if (length !== undefined) {
      code = candidate;
      value = digits.substring(length);
      break;
    }
  }
  
  if (!code) {
    const codeMatch = phoneWithPlus.match(/^\+(\d{1,3})/);
    if (codeMatch) {
      code = '+' + codeMatch[1];
      value = digits.substring(codeMatch[1].length);
    }
  }

  return {
    code: code,
    value: value,
  };
}